import React from "react";
import CustomerSettings from "../../views/CustomerSettings";

const CustomerSettingsPage = () => {
  return <CustomerSettings />;
};

export default CustomerSettingsPage;
